import React, { useEffect, useState } from 'react';
import {
  Col,
  Row,
  Button,
  Card,
  Form,
  Modal,
  Tabs,
  Tab
} from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import SmAreaDropdown from 'components/dropdowns/SkillMatrix/SmAreaDropdown';
import SmSkillLevelDropdown from 'components/dropdowns/SkillMatrix/SmSkillLevelDropdown';
import {
  post,
  getByParam,
  patch
} from 'services/skill-matric-services/smAreaLevelConfigService';
import { trainingUnits } from 'data/TempData';
import { toast } from 'react-toastify';
import BasicTemplate from 'components/Toast/BasicTemplate';

export default function AreaSkillLevelConfig() {
  const defaultSelect = {
    trainingDuration: 0,
    trainingDurationUnit: 0,
    notifyBefore: 0,
    notifyBeforeUnit: 0
  };
  const [formData, setFormData] = useState({
    areaId: null,
    skillLevelId: null,
    data: null,
    dataObj: { ...defaultSelect }
  });

  const [initialDataObj, setInitialDataObj] = useState({ ...defaultSelect });

  const [baseParamRequest] = useState({ isGetAll: true });

  const handleFilterInsideChange = (key, option) => {
    const newFormData = { ...formData, [key]: option.id };
    setFormData(newFormData);
  };

  const reloadConfig = async (skillLevelId, areaId) => {
    if (skillLevelId && areaId) {
      try {
        const res = await getByParam(skillLevelId, areaId);
        if (res.success && res.data) {
          const dataObj = JSON.parse(res.data.data) || { ...defaultSelect };
          setFormData(prev => ({
            ...prev,
            id: res.data.id,
            data: res.data,
            dataObj
          }));
          setInitialDataObj(dataObj);
        } else {
          const emptyObj = { ...defaultSelect };
          setFormData(prev => ({
            ...prev,
            data: null,
            id: null,
            dataObj: emptyObj
          }));
          setInitialDataObj(emptyObj);
        }
      } catch (error) {
        console.error('Error fetching config:', error);
        const emptyObj = { ...defaultSelect };
        setFormData(prev => ({
          ...prev,
          data: null,
          id: null,
          dataObj: emptyObj
        }));
        setInitialDataObj(emptyObj);
      }
    }
  };

  const handleSave = async () => {
    try {
      const payload = {
        ...formData,
        data: JSON.stringify(formData.dataObj)
      };
      if (formData.id > 0) {
        await patch(formData.skillLevelId, formData.areaId, formData);
      } else {
        await post(payload);
      }
      toast.success(
        <BasicTemplate success={true} text="Successfully saved!" />
      );
      setInitialDataObj(formData.dataObj);
    } catch (error) {
      console.error('Error saving config:', error);
    }
  };

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setFormData(prev => {
      const updatedDataObj = { ...prev.dataObj, [name]: value };
      return {
        ...prev,
        dataObj: updatedDataObj,
        data: JSON.stringify(updatedDataObj)
      };
    });
  };

  const isDirty =
    JSON.stringify(formData.dataObj) !== JSON.stringify(initialDataObj);

  useEffect(() => {
    if (formData.areaId && formData.skillLevelId) {
      reloadConfig(formData.skillLevelId, formData.areaId);
    }
  }, [formData.areaId, formData.skillLevelId]);

  return (
    <>
      <Row>
        <Col xs={12}>
          <PageHeader
            title="Trainee's Document"
            description=""
            className="mb-3"
            col={{ lg: 12 }}
          />
        </Col>
        <Col xs={12}>
          <Col lg={12}>
            <Row className="g-3 mb-3">
              <Card className="mb-3">
                <Card.Body className="bg-light">
                  <Row style={{ paddingBottom: '10px' }}>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Area</Form.Label>
                        <SmAreaDropdown
                          param={{}}
                          handleChange={handleFilterInsideChange}
                          selectedOptions={formData.areaId}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Skill Level</Form.Label>
                        <SmSkillLevelDropdown
                          isMulti={false}
                          param={baseParamRequest}
                          handleChange={handleFilterInsideChange}
                          selectedOptions={formData.skillLevelId}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Row>

            {formData.areaId > 0 && formData.skillLevelId > 0 && (
              <Row className="g-3 mb-3">
                <Card show={true} contentClassName="border" size="lg">
                  <Form onSubmit={e => e.preventDefault()}>
                    <Card.Header
                      closeButton
                      className="bg-light px-card border-bottom-0"
                    >
                      <Card.Title as="h5">Settings</Card.Title>
                    </Card.Header>
                    <Modal.Body className="p-card">
                      <Tabs
                        defaultActiveKey="user-files"
                        id="file-management-tabs"
                        className="mb-3"
                      >
                        <Tab eventKey="user-files" title="Training Config">
                          <div className="row">
                            <div className="col-md-4">
                              <div className="border rounded p-3 shadow-sm bg-light">
                                <h5 className="mb-3">Training Duration</h5>
                                <div className="d-flex gap-2 mb-3">
                                  <Form.Control
                                    type="number"
                                    name="trainingDuration"
                                    required
                                    value={
                                      formData.dataObj.trainingDuration || 0
                                    }
                                    onChange={handleChange}
                                    min={1}
                                    placeholder="Enter number"
                                  />
                                  <Form.Select
                                    name="trainingDurationUnit"
                                    value={
                                      formData.dataObj.trainingDurationUnit || 0
                                    }
                                    onChange={handleChange}
                                  >
                                    {trainingUnits.map(unit => (
                                      <option
                                        key={unit.value}
                                        value={unit.value}
                                      >
                                        {unit.label}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </div>
                                <h5 className="mb-3">Notify Before</h5>
                                <div className="d-flex gap-2 mb-3">
                                  <Form.Control
                                    type="number"
                                    name="notifyBefore"
                                    required
                                    value={formData.dataObj.notifyBefore || 0}
                                    onChange={handleChange}
                                    min={0}
                                    placeholder="Enter number"
                                  />
                                  <Form.Select
                                    name="notifyBeforeUnit"
                                    value={
                                      formData.dataObj.notifyBeforeUnit || 0
                                    }
                                    onChange={handleChange}
                                  >
                                    {trainingUnits.map(unit => (
                                      <option
                                        key={unit.value}
                                        value={unit.value}
                                      >
                                        {unit.label}
                                      </option>
                                    ))}
                                  </Form.Select>
                                </div>
                                <div className="text-end">
                                  <Button
                                    variant="primary"
                                    onClick={handleSave}
                                    disabled={!isDirty}
                                  >
                                    Save
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab>
                      </Tabs>
                    </Modal.Body>
                  </Form>
                </Card>
              </Row>
            )}
          </Col>
        </Col>
      </Row>
    </>
  );
}
